import {
  Component,
  Input,
  ContentChild,
  TemplateRef,
  ViewChild,
  AfterViewInit,
  OnInit,
  OnChanges,
  EventEmitter,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCheckboxModule, MatCheckboxChange } from '@angular/material/checkbox';
import { DateFormatPipe } from '../../pipes/date-format.pipe';
import { TableColumn } from '../../../core/models/column.model';

@Component({
  selector: 'app-table',
  standalone: true,
  imports: [CommonModule, MatPaginatorModule, MatSortModule, MatTableModule, MatCheckboxModule, DateFormatPipe],
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() columns: TableColumn[] = [];
  @Input() data: any[] = [];
  @Input() tableType: string = '';
  @Input() pageSizeOptions: number[] = [5, 10, 20]; // Configuración de opciones de página
  @Input() initialPageSize: number = 10; // Tamaño inicial de página
  @ContentChild('actionTemplate', { static: true }) actionTemplate: TemplateRef<any> | null = null;
  @Output() checkboxChange = new EventEmitter<{ id: number; checked: boolean }>();
  @Output() selectAllChange = new EventEmitter<{ checked: boolean; type: string; visibleData?: any[] }>();

  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<any>(this.data);

  @ViewChild(MatPaginator) paginator: MatPaginator | null = null;
  @ViewChild(MatSort) sort: MatSort | null = null;

  ngOnInit() {
    this.displayedColumns = [...this.columns.map(c => c.field), 'actions'];
    this.dataSource.data = this.data;

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    
    // Configurar el tamaño inicial de página
    if (this.paginator) {
      this.paginator.pageSize = this.initialPageSize;
    }
  }

  ngOnChanges() {
    // Actualizar columnas mostradas cuando cambia el input de columnas
    this.displayedColumns = [...this.columns.map(c => c.field), 'actions'];
    // Actualizar datos cuando cambia el input de data
    this.dataSource.data = this.data;
  }

  getNestedValue(obj: any, path: string): any {
    //{ header: 'Hora', field: 'hora', width: '100px' }, ejemplo de colummn
  
    let objetoReturn = path.split('.').reduce((acc, part) => acc && acc[part], obj);
    // if(path == 'hora'){
    //   console.log(objetoReturn)
    //   if(!objetoReturn) console.log('obj', obj)
      
    // }
    return objetoReturn

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  emitCheckboxChange(event: MatCheckboxChange, element: any): void {
    const checked = event.checked;
    this.checkboxChange.emit({ id: element.id, checked });
  }

  areAllSelected(): boolean {
    const checkboxColumn = this.columns.find(col => col.isCheckbox);
    if (!checkboxColumn) return false;
    
    // Obtener solo los datos de la página actual (considerando paginación)
    const currentPageData = this.getCurrentPageData();
    return currentPageData.length > 0 && currentPageData.every(item => this.getNestedValue(item, checkboxColumn.field));
  }

  isIndeterminate(): boolean {
    const checkboxColumn = this.columns.find(col => col.isCheckbox);
    if (!checkboxColumn) return false;
    
    // Obtener solo los datos de la página actual (considerando paginación)
    const currentPageData = this.getCurrentPageData();
    const selectedCount = currentPageData.filter(item => this.getNestedValue(item, checkboxColumn.field)).length;
    return selectedCount > 0 && selectedCount < currentPageData.length;
  }

  getCurrentPageData(): any[] {
    if (!this.paginator) {
      return this.dataSource.filteredData;
    }
    
    const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    const endIndex = startIndex + this.paginator.pageSize;
    return this.dataSource.filteredData.slice(startIndex, endIndex);
  }

  onSelectAllChange(event: MatCheckboxChange): void {
    // Obtener solo los datos de la página actual (considerando filtros y paginación)
    const currentPageData = this.getCurrentPageData();
    
    this.selectAllChange.emit({ 
      checked: event.checked, 
      type: this.tableType,
      visibleData: currentPageData
    });
  }
}
